import apolloClient from '../../apolloClient';
import userQueries from '../queries/user';
import userMutation from '../mutations/user';

const getCurrentUser = async (variables) =>
  apolloClient.query({
    query: userQueries.GET_CURRENT_USER,
    variables,
    fetchPolicy: 'no-cache',
  });

const updateUser = async (variables) =>
  apolloClient.mutate({
    mutation: userMutation.UPDATE_USER,
    fetchPolicy: 'no-cache',
    variables,
  });

const getUserById = async (variables) =>
  apolloClient.query({
    query: userQueries.GET_USER_BY_ID,
    fetchPolicy: 'no-cache',
    variables,
  });

export default {
  getCurrentUser,
  updateUser,
  getUserById,
};
